


























































import { Component, Prop, Vue } from "vue-property-decorator";
import { getFormattedDateTime } from "@/utility/DateUtils";

interface TesLab {
  nama_test: string;
  hasil: string;
  satuan: string;
  nilai_normal: string;
  flag: string | null;
}

interface SampelLab {
  lis_sampel: string;
  tgl_order: string;
  acc_date: string;
  acc_by: string;
  dokter: string | null;
  catatan: string | null;
  items: TesLab[] | null;
}

@Component
export default class HasilLabSampel extends Vue {
  @Prop({ required: true }) readonly sampel!: SampelLab;
  @Prop({ type: Boolean, default: false }) readonly lebar!: boolean;

  get daftarTes(): TesLab[] {
    return this.sampel.items || [];
  }

  get tinggiTabel(): string | undefined {
    return !this.lebar && this.daftarTes.length > 8 ? "300px" : undefined;
  }

  abnormal(flag: string | null): boolean {
    const nilai = (flag || "").trim();
    return nilai !== "" && nilai !== "*";
  }

  formatTanggal(val: string): string {
    return getFormattedDateTime(val, "DD-MM-YYYY");
  }

  formatWaktu(val: string): string {
    return getFormattedDateTime(val, "DD-MM-YYYY HH:mm");
  }
}
